/* eslint-disable */

export enum ConstraintType {
	Some = 0,
	Every = 1,
	Required = 2,
	Min = 3,
	Max = 4,
	MinMax = 5,
	Master = 6,
	Requires = 7,
	
}
